export default "__VITE_ASSET__BiBMQFjZ__"